import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgAppleLogo = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M20.722 14.677c-.011-1.95.871-3.422 2.656-4.506-.999-1.43-2.508-2.216-4.5-2.37-1.887-.148-3.948 1.1-4.703 1.1-.797 0-2.625-1.047-4.06-1.047C7.152 7.902 4 10.22 4 14.932c0 1.392.255 2.83.765 4.315.68 1.95 3.135 6.732 5.696 6.652 1.34-.032 2.285-.951 4.028-.951 1.69 0 2.566.951 4.06.951 2.582-.037 4.803-4.384 5.451-6.339-3.464-1.631-3.278-4.782-3.278-4.883Zm-3.008-8.725c1.45-1.721 1.318-3.289 1.275-3.852-1.28.074-2.763.871-3.607 1.854-.93 1.052-1.478 2.354-1.36 3.82 1.386.107 2.65-.605 3.692-1.822Z" />
  </svg>
);
export default SvgAppleLogo;
